import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { BookOpen } from "lucide-react";

export const Knowledge = () => {
  const { data } = useQuery({ queryKey: ["knowledge"], queryFn: async () => (await api.get("/knowledge")).data });
  const items = data || [];
  return (
    <div className="space-y-6" data-testid="page-knowledge">
      <header>
        <div className="font-mono-cad text-[10px] uppercase tracking-[0.28em] text-[#7C93A5]">Knowledge360™</div>
        <h1 className="font-display text-3xl font-bold text-[#F6F8FA] mt-1">Governed Cadastre Knowledge</h1>
        <div className="text-[13px] text-[#B3C2CC] mt-1">Legislation, standards, procedures and precedents — versioned with effective dates.</div>
      </header>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {items.map((k) => (
          <div key={k.id} className="cad-panel p-5" data-testid={`knowledge-${k.id}`}>
            <div className="flex items-center justify-between">
              <span className="cad-chip cad-chip-gold">{k.category}</span>
              <span className="cad-chip cad-chip-green">{k.status?.replace("_", " ")}</span>
            </div>
            <div className="font-display font-bold text-[#F6F8FA] mt-2 flex items-center gap-2"><BookOpen size={14} className="text-[#C99A2E]"/> {k.title}</div>
            <div className="text-[13px] text-[#B3C2CC] mt-2">{k.summary}</div>
            <div className="text-[11px] font-mono-cad text-[#7C93A5] mt-3">Effective {k.effective_date}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
